import {IDigitalMaterialWizardState} from "../../../types/ui/wizard/digital-material";
import {defaultDigitalMaterial, DigitalMaterialEditingMode} from "../../../types/types";

export const initialDigitalMaterialState: IDigitalMaterialWizardState = {
  mode: DigitalMaterialEditingMode.CreateNew,
  material: defaultDigitalMaterial,
  orgMaterial: defaultDigitalMaterial,
  calcIds: []
};
